
<template>
  <div>
    <v-autocomplete v-model="order.brand" label="Marca" :items="brands" :loading="loading.brands" 
      item-text="name" return-object :rules="[...required]" prepend-icon="mdi-package-variant-closed">
      <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
    </v-autocomplete>

    <template v-if="order.brand?.id">
      <v-select :rules="[...required]" :items="segments" v-model="order.segment_id" :loading="loading.segments"
        item-text="name" item-value="id" label="Segmento" prepend-icon="mdi-information">
      </v-select>

      <v-autocomplete v-model="order.pickup_location" :loading="loading.pickup_locations" :items="pickup_locations"
        item-text="name" label="Local de retirada" prepend-icon="mdi-domain" :rules="[...required]" return-object>
        <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
      </v-autocomplete>

      <div class="d-flex justify-center mb-1" v-if="order.pickup_location != null">
        <v-btn v-if="products_count > 1" small color="grey" class="white--text mx-1" @click="decrementProductsCount"> 
          <v-icon left small>mdi-minus</v-icon> Produto 
        </v-btn>
        <v-btn small color="red darken-1" class="white--text mx-1" @click="incrementProductsCount"
          :disabled="products_count >= products.length"> 
          <v-icon left small>mdi-plus</v-icon>
          Produto 
        </v-btn>
      </div>
      
      <div v-for="i in products_count" class="px-3 mb-4" :key="i" v-if="order.pickup_location != null" style="border: 1px solid #b1b1b1; border-radius: 8px;">
        <v-row class="py-3">
          <v-col cols="12" class="pb-0">
            <v-autocomplete label="Produto" v-model="order.items_attributes[i - 1].product"
              :items="products" item-text="name" :loading="loading.products" :rules="[...required]"
              prepend-icon="mdi-domain" hide-no-data return-object>
              <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-text-field label="Quantidade (sacos)" v-model="order.items_attributes[i - 1].total_bags" 
              prepend-icon="mdi-cart" :rules="[...required]" type="number">
            </v-text-field>
          </v-col>

          <v-col cols="12" class="py-0">
            <v-text-field v-money="money" label="Preço de venda (R$)" v-model="order.items_attributes[i - 1].bag_sell_price"
              prepend-icon="mdi-cash" :rules="[...required]">
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="6" class="py-0 pb-3  text-subtitle-1">
            <span>Total da venda:</span> 
            <span class="font-weight-bold ml-1 black--text">{{ Number(order.items_attributes[i - 1]?.bag_sell_price?.toString().replace(/,/g, '') * order.items_attributes[i - 1]?.total_bags || 0).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})  }}</span>
          </v-col>

          <v-col cols="12" class="py-0">
            <v-text-field v-money="money" label="Frete unitário (R$)" v-model="order.items_attributes[i - 1].unit_shipping_price"
              prepend-icon="mdi-truck" :rules="not_negative_optional">
            </v-text-field>
          </v-col>
          
          <v-col cols="12" sm="6" class="py-0  pb-3 text-subtitle-1">

            <span>Total do frete:</span> 
            <span class="font-weight-bold ml-1 black--text">{{ Number((order.items_attributes[i - 1]?.unit_shipping_price?.toString().replace(/,/g, '') * order.items_attributes[i - 1]?.total_bags) || 0).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'}) }}</span>
          </v-col>
          
          
        </v-row>
        
        

      </div>
    </template>

    <!-- <v-text-field label="Total da venda" readonly prepend-icon="mdi-cash-multiple"
      :value="`R$ ${total_sell_price}`" v-if="order.pickup_location">
    </v-text-field> -->
  </div>
</template>

<script>
import validations from "@/mixins/validations";
import { VMoney } from 'v-money'
import Api from '@/api/index';

export default {
  name: 'SelectWholesaleProducts',
  mixins: [validations],
  directives: {money: VMoney},
  props: {
    order: {
      type: [Object],
    },
    stepper_count: {
      type: [Number, String]
    }
  },
  data() {
    return {
      products_count: 1,
      brands: [],
      segments: [],
      pickup_locations: [],
      products: [],
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: false
      },
      loading: {
        pickup_locations: false,
        segments: false,
        brands: false,
        products: false,
      },
      not_negative_optional: [
        v => {
          if (v === null || v === undefined || v === '') return true
          return Number(String(v).replace(/,/g, '')) >= 0 || 'Não pode ser negativo'
        }
      ],
    }
  },
  methods: {
    getData() {
      this.getBrands()
      this.getPickupLocationsByBrand()
      this.getSegmentsByBrand()
      this.getProducts()
    },
    getProducts(){
      this.products = []
      if( this.order.pickup_location?.id && this.order.segment_id ){
        this.loading.products = true
        let params = {
          segment_id: this.order.segment_id,
          pickup_location_id: this.order.pickup_location.id
        }
        Api.Product.index( params ).then(res => res.data).then( res => {
          this.products = [...res]
          this.syncSelectedProductsWithPickupLocation()
        }).finally(()=>{
          this.loading.products = false
        })
      }
    },
    checkStepper(){
      if(this.stepper_count == 6 || this.stepper_count == '6'){
        this.changeOrderBags()
      }
    },
    changeOrderBags() {
      this.syncSelectedProductsWithPickupLocation()
      var order_items = this.order.items_attributes
      this.order.total_order_bags = 0
      this.order.total_order_sell = 0

      order_items.forEach((item, idx) => {
        item.product_id = item.product.id
        
        item.pickup_location_id = this.order.pickup_location.id
        this.order.pickup_location_id = this.order.pickup_location.id
        item.bag_sell_price = Number(item.bag_sell_price.toString().replace(/,/g, ''))
        item.unit_shipping_price = Number(String(item.unit_shipping_price || 0).replace(/,/g, ''))
        item.total_items_sell = Number((item.total_bags * item.bag_sell_price))
        this.order.total_order_bags += parseInt(item.total_bags)
        this.order.total_order_sell += parseFloat(item.bag_sell_price * item.total_bags)

        item.product_pickup_location_id = item.product.product_pickup_locations_id
        this.order.product_pickup_location_id = item.product.product_pickup_locations_id
        
      })
    },
    syncSelectedProductsWithPickupLocation() {
      if (!this.order.pickup_location?.id || !this.products.length) return

      this.order.items_attributes.forEach((item) => {
        if (!item.product && !item.product_id) return

        const productId = item.product?.id || item.product_id
        const productForPickup = this.products.find(product => Number(product.id) == Number(productId))

        if (productForPickup) {
          item.product = productForPickup
          item.product_id = productForPickup.id
          item.pickup_location_id = this.order.pickup_location.id
          item.product_pickup_location_id = productForPickup.product_pickup_locations_id
        } else {
          item.product = null
          item.product_id = null
          item.product_pickup_location_id = null
        }
      })
    },
    incrementProductsCount() {
      if (this.products_count <= this.products.length) {
        this.order.items_attributes.push({ unit_shipping_price: '0.00' })
        this.products_count++
      }
    },
    decrementProductsCount(){
      if (this.products_count > 1){
        this.products_count--
        this.order.items_attributes.pop()
      } 
    },
    getBrands() {
      this.loading.brands = true
      Api.Brand.index().then(r => r.data).then(res => {
        this.brands = [...res]
      }).finally(()=>{
        this.loading.brands = false
      })
    },
    getPickupLocationsByBrand() {
      if(this.order.brand?.id){
        this.loading.pickup_locations = true
        let params = { brand_id: this.order.brand?.id}
  
        Api.PickupLocation.index( params ).then(r => r.data).then(res => {
          this.pickup_locations = [...res]
        }).finally(() => {
          this.loading.pickup_locations = false
        })
      }
    },
    getSegmentsByBrand() {
      if(this.order.brand?.id){
        this.loading.segments = true
        let params = { brand_id: this.order.brand?.id}
        Api.Segment.index(params).then(r => r.data).then(res => {
          this.segments = [...res]
        }).finally(() => {
          this.loading.segments = false
        })
      }
    },
  },
  computed: {
    total_sell_price() {
      var total_aux = 0
      this.order.items_attributes.forEach(item => {
        item.bag_sell_price ? total_aux += Number(item.total_bags) * Number(item.bag_sell_price.toString().replace(/,/g, '')) : null
      });
      return Number(total_aux || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    },
  },
  mounted() {
    this.getData()
    this.products_count = this.order.items_attributes.length || 1
  },
  watch:{
    'order.brand'() {
      this.getPickupLocationsByBrand()
      this.getSegmentsByBrand()
    },
    'order.segment_id'(){
      this.getProducts()
    },
    'order.pickup_location.id'(){
      this.getProducts()
    },
    stepper_count(){
      this.checkStepper()
    }
  }
}
</script>